import React from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import IconBox from './IconBox';
import iconlist from './icon_list';

const IconList = () => (
  <Col md={12}>
    <Card className="panel panel--primary" id="users_table">
      <CardBody className="panel__body">
        <div className="panel__title bg_blue m-b-35">
          <h5 className="bold-text">ICONS</h5>
        </div>
        <div className="panel__content">
          <IconBox icons={iconlist} />
        </div>
      </CardBody>
    </Card>
  </Col>
);

export default IconList;
